<div class="resources-container">
  <resources-lnb *ngIf="currentUrl?.includes('/resources/')"></resources-lnb>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>